import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { bulletinBoardSchema } from '../../../common/validations'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

import { get } from 'api/apiClient'
import { Language, toSupportedLanguage } from 'i18n/i18n'

const params = (contractUuid: string, lang: Language) => {
  const basePath = API_ENDPOINTS.BULLETINS.replace(
    ':contractUuid',
    contractUuid
  )
  const searchParams = new URLSearchParams({ page: '0', language: lang })
  const path = `${basePath}?${searchParams.toString()}`

  return {
    cacheTime: 59000,
    queryKey: ['bulletins', contractUuid, lang],
    queryFn: async () => {
      const response = await get(path, bulletinBoardSchema)

      return {
        bulletins: response.bulletins,
        hasMoreBulletins: response.nextPage !== null,
      }
    },
  }
}

export const useAPIGetBulletins = (contractUuid: string) => {
  const { i18n } = useTranslation()

  return useQuery(
    params(contractUuid, toSupportedLanguage(i18n.resolvedLanguage))
  )
}

export const useAPIGetBulletinsSuspense = (contractUuid: string) => {
  const { i18n } = useTranslation()

  return useSuspenseQuery(
    params(contractUuid, toSupportedLanguage(i18n.resolvedLanguage))
  )
}
